/* Gallery2 product pages: load the lower carousel module near its section. */
const moduleRequests = new Map();
class GL2DeferredGridModule extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section');
    this.load = () => {
      this.observer?.disconnect();
      const src = this.dataset.src;
      if (!src || customElements.get('grid-slider')) return;
      if (!moduleRequests.has(src)) {
        moduleRequests.set(src, import(src).catch((error) => {
          moduleRequests.delete(src);
          console.error('Gallery2 carousel module could not load', error);
        }));
      }
    };
    if (!section || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    this.section = section;
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load();
    }, { rootMargin: '900px 0px' });
    this.observer.observe(section);
    section.addEventListener('focusin', this.load);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.section?.removeEventListener('focusin', this.load);
  }
}
if (!customElements.get('gl2-deferred-grid-module')) {
  customElements.define('gl2-deferred-grid-module', GL2DeferredGridModule);
}
